/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AutomaticInvestigationCompletedSuccessfullyRequestDto,
  AutomaticValidationRequest,
  CommonRequestDto,
  CompleteCredentialIssuanceWorkflowRequest,
  ManualValidationStillNeededRequestDto,
  ResponseDto,
  StartManualValidationDto,
  SupervisorRejectsOrgDto,
} from '../models/index';
import {
    AutomaticInvestigationCompletedSuccessfullyRequestDtoFromJSON,
    AutomaticInvestigationCompletedSuccessfullyRequestDtoToJSON,
    AutomaticValidationRequestFromJSON,
    AutomaticValidationRequestToJSON,
    CommonRequestDtoFromJSON,
    CommonRequestDtoToJSON,
    CompleteCredentialIssuanceWorkflowRequestFromJSON,
    CompleteCredentialIssuanceWorkflowRequestToJSON,
    ManualValidationStillNeededRequestDtoFromJSON,
    ManualValidationStillNeededRequestDtoToJSON,
    ResponseDtoFromJSON,
    ResponseDtoToJSON,
    StartManualValidationDtoFromJSON,
    StartManualValidationDtoToJSON,
    SupervisorRejectsOrgDtoFromJSON,
    SupervisorRejectsOrgDtoToJSON,
} from '../models/index';

export interface CompleteInstance3Request {
    workflowInstanceId: string;
    completeCredentialIssuanceWorkflowRequest: CompleteCredentialIssuanceWorkflowRequest;
}

export interface NotifyAutomaticInvestigationCompletedSuccessfullyRequest {
    automaticValidationRequest: AutomaticValidationRequest;
}

export interface NotifyAutomaticInvestigationCompletedSuccessfully1Request {
    automaticInvestigationCompletedSuccessfullyRequestDto: AutomaticInvestigationCompletedSuccessfullyRequestDto;
}

export interface NotifyAutomaticInvestigationTimeoutRequest {
    commonRequestDto: CommonRequestDto;
}

export interface NotifyIssuingFailedRequest {
    commonRequestDto: CommonRequestDto;
}

export interface NotifyManualInvestigationTimeoutRequest {
    commonRequestDto: CommonRequestDto;
}

export interface NotifyManualValidationStillNeededRequest {
    manualValidationStillNeededRequestDto: ManualValidationStillNeededRequestDto;
}

export interface NotifySupervisorRejectsOrgRequest {
    supervisorRejectsOrgDto: SupervisorRejectsOrgDto;
}

export interface StartManualCheckRequest {
    startManualValidationDto: StartManualValidationDto;
}

export interface TerminateInstance1Request {
    workflowInstanceId: string;
}

/**
 * 
 */
export class PrivateBronzeIdControllerApi extends runtime.BaseAPI {

    /**
     * Complete Bronze id workflow instance
     */
    async completeInstance3Raw(requestParameters: CompleteInstance3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['workflowInstanceId'] == null) {
            throw new runtime.RequiredError(
                'workflowInstanceId',
                'Required parameter "workflowInstanceId" was null or undefined when calling completeInstance3().'
            );
        }

        if (requestParameters['completeCredentialIssuanceWorkflowRequest'] == null) {
            throw new runtime.RequiredError(
                'completeCredentialIssuanceWorkflowRequest',
                'Required parameter "completeCredentialIssuanceWorkflowRequest" was null or undefined when calling completeInstance3().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/bronze-id/{workflow_instance_id}/completion`.replace(`{${"workflow_instance_id"}}`, encodeURIComponent(String(requestParameters['workflowInstanceId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteCredentialIssuanceWorkflowRequestToJSON(requestParameters['completeCredentialIssuanceWorkflowRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Complete Bronze id workflow instance
     */
    async completeInstance3(requestParameters: CompleteInstance3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.completeInstance3Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start automatic investigation
     */
    async notifyAutomaticInvestigationCompletedSuccessfullyRaw(requestParameters: NotifyAutomaticInvestigationCompletedSuccessfullyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['automaticValidationRequest'] == null) {
            throw new runtime.RequiredError(
                'automaticValidationRequest',
                'Required parameter "automaticValidationRequest" was null or undefined when calling notifyAutomaticInvestigationCompletedSuccessfully().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/bronze-id/start/automatic-investigation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AutomaticValidationRequestToJSON(requestParameters['automaticValidationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Start automatic investigation
     */
    async notifyAutomaticInvestigationCompletedSuccessfully(requestParameters: NotifyAutomaticInvestigationCompletedSuccessfullyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.notifyAutomaticInvestigationCompletedSuccessfullyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Requested by State Machine service. Does not close the workflow and does not update any data in DB
     * Notify that automatic investigation is successful
     */
    async notifyAutomaticInvestigationCompletedSuccessfully1Raw(requestParameters: NotifyAutomaticInvestigationCompletedSuccessfully1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['automaticInvestigationCompletedSuccessfullyRequestDto'] == null) {
            throw new runtime.RequiredError(
                'automaticInvestigationCompletedSuccessfullyRequestDto',
                'Required parameter "automaticInvestigationCompletedSuccessfullyRequestDto" was null or undefined when calling notifyAutomaticInvestigationCompletedSuccessfully1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/bronze-id/notify/automatic-investigation-successful`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AutomaticInvestigationCompletedSuccessfullyRequestDtoToJSON(requestParameters['automaticInvestigationCompletedSuccessfullyRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Requested by State Machine service. Does not close the workflow and does not update any data in DB
     * Notify that automatic investigation is successful
     */
    async notifyAutomaticInvestigationCompletedSuccessfully1(requestParameters: NotifyAutomaticInvestigationCompletedSuccessfully1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.notifyAutomaticInvestigationCompletedSuccessfully1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Requested by State Machine service. Does not close the workflow and does not update any data in DB
     * Notify users that Automatic investigation timeout exceeded
     */
    async notifyAutomaticInvestigationTimeoutRaw(requestParameters: NotifyAutomaticInvestigationTimeoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['commonRequestDto'] == null) {
            throw new runtime.RequiredError(
                'commonRequestDto',
                'Required parameter "commonRequestDto" was null or undefined when calling notifyAutomaticInvestigationTimeout().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/bronze-id/notify/automatic-investigation-timeout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CommonRequestDtoToJSON(requestParameters['commonRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Requested by State Machine service. Does not close the workflow and does not update any data in DB
     * Notify users that Automatic investigation timeout exceeded
     */
    async notifyAutomaticInvestigationTimeout(requestParameters: NotifyAutomaticInvestigationTimeoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.notifyAutomaticInvestigationTimeoutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Requested by State Machine service. Does not close the workflow and does not update any data in DB
     * Notify users that Automatic credential Issuing failed
     */
    async notifyIssuingFailedRaw(requestParameters: NotifyIssuingFailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['commonRequestDto'] == null) {
            throw new runtime.RequiredError(
                'commonRequestDto',
                'Required parameter "commonRequestDto" was null or undefined when calling notifyIssuingFailed().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/bronze-id/notify/issuing-failed`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CommonRequestDtoToJSON(requestParameters['commonRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Requested by State Machine service. Does not close the workflow and does not update any data in DB
     * Notify users that Automatic credential Issuing failed
     */
    async notifyIssuingFailed(requestParameters: NotifyIssuingFailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.notifyIssuingFailedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Requested by State Machine service. Does not close the workflow and does not update any data in DB
     * Notify users that Manual investigation timeout exceeded
     */
    async notifyManualInvestigationTimeoutRaw(requestParameters: NotifyManualInvestigationTimeoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['commonRequestDto'] == null) {
            throw new runtime.RequiredError(
                'commonRequestDto',
                'Required parameter "commonRequestDto" was null or undefined when calling notifyManualInvestigationTimeout().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/bronze-id/notify/manual-investigation-timeout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CommonRequestDtoToJSON(requestParameters['commonRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Requested by State Machine service. Does not close the workflow and does not update any data in DB
     * Notify users that Manual investigation timeout exceeded
     */
    async notifyManualInvestigationTimeout(requestParameters: NotifyManualInvestigationTimeoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.notifyManualInvestigationTimeoutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Requested by State Machine service. Does not close the workflow and does not update any data in DB
     * Notify that manual investigation is still requested
     */
    async notifyManualValidationStillNeededRaw(requestParameters: NotifyManualValidationStillNeededRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['manualValidationStillNeededRequestDto'] == null) {
            throw new runtime.RequiredError(
                'manualValidationStillNeededRequestDto',
                'Required parameter "manualValidationStillNeededRequestDto" was null or undefined when calling notifyManualValidationStillNeeded().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/bronze-id/notify/manual-validation-still-needed`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManualValidationStillNeededRequestDtoToJSON(requestParameters['manualValidationStillNeededRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Requested by State Machine service. Does not close the workflow and does not update any data in DB
     * Notify that manual investigation is still requested
     */
    async notifyManualValidationStillNeeded(requestParameters: NotifyManualValidationStillNeededRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.notifyManualValidationStillNeededRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Requested by State Machine service. Does not close the workflow and does not update any data in DB
     * Notify users that Supervisor rejected the org
     */
    async notifySupervisorRejectsOrgRaw(requestParameters: NotifySupervisorRejectsOrgRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['supervisorRejectsOrgDto'] == null) {
            throw new runtime.RequiredError(
                'supervisorRejectsOrgDto',
                'Required parameter "supervisorRejectsOrgDto" was null or undefined when calling notifySupervisorRejectsOrg().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/bronze-id/notify/supervisor-rejects`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupervisorRejectsOrgDtoToJSON(requestParameters['supervisorRejectsOrgDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Requested by State Machine service. Does not close the workflow and does not update any data in DB
     * Notify users that Supervisor rejected the org
     */
    async notifySupervisorRejectsOrg(requestParameters: NotifySupervisorRejectsOrgRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.notifySupervisorRejectsOrgRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Called from SM. Notifies workflow service that manual validation should start
     * Request for manual validation
     */
    async startManualCheckRaw(requestParameters: StartManualCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['startManualValidationDto'] == null) {
            throw new runtime.RequiredError(
                'startManualValidationDto',
                'Required parameter "startManualValidationDto" was null or undefined when calling startManualCheck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/bronze-id/start-manual-validation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartManualValidationDtoToJSON(requestParameters['startManualValidationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Called from SM. Notifies workflow service that manual validation should start
     * Request for manual validation
     */
    async startManualCheck(requestParameters: StartManualCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.startManualCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Terminate Bronze id workflow instance
     */
    async terminateInstance1Raw(requestParameters: TerminateInstance1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['workflowInstanceId'] == null) {
            throw new runtime.RequiredError(
                'workflowInstanceId',
                'Required parameter "workflowInstanceId" was null or undefined when calling terminateInstance1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/.private/bronze-id/{workflow_instance_id}/terminate`.replace(`{${"workflow_instance_id"}}`, encodeURIComponent(String(requestParameters['workflowInstanceId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Terminate Bronze id workflow instance
     */
    async terminateInstance1(requestParameters: TerminateInstance1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.terminateInstance1Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
